module.exports = __webpack_public_path__ + "static/media/LockMenu0.5466fc4b.png";